<template>
    <div>
        <!-- Modal de Alertas -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Atenção</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="alertas">
                        <div v-if="alertas.plano" class="alert alert-secondary">
                            {{ alertas.plano.search }}
                        </div>
                        
                        <div class="list-group">
                            <a href="#" class="list-group-item list-group-item-action" :class="'list-group-item-' + alerta.color" v-for="(alerta, iax) in alertas.lista" :key="iax">
                                <h4>{{ alerta.procedimento }}</h4>
                                <div v-if="alerta.msg" style="white-space: pre-wrap;">{{ alerta.msg }} </div>
                                <div v-if="alerta.obs" style="white-space: pre-wrap;">{{ alerta.obs }} </div>
                            </a>
                        </div>
                        <pre v-if="false">{{ alertas }}</pre>
                    </div>
                    <div class="modal-footer" v-if="alertas">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Cancelar</button>
                        <az-submit @click="callback(true)" :disabled="tem_alerta_block" v-if="callback">Confirmar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzSubmit from "../../util/AzSubmit.vue";

export default {
    data() {
        return { 
            alertas: null, 
            modal_id: "", 
            callback: null, 
        };
    },

    components: { 
        AzSubmit, 
    },

    computed: { 
        modal_name: function () { 
            return 'orderSetAlertasModal' + this.modal_id; 
        },

        tem_alerta_block: function () { 
            if ( this.alertas && this.alertas.lista && this.alertas.lista.find(item => item.block) ) { 
                return true;
            }

            return false;
        },
    },

    methods: { 
        abrir (alertas, callback) { 
            console.log('Abrir', this.modal_name);
            console.log('alertas', alertas);

            this.alertas = alertas;
            this.callback = callback; 

            $('#' + this.modal_name).modal('show'); 
        },  

        fechar_modal() { 
            $('#' + this.modal_name).modal('hide'); 
        }
    },
    
    mounted() { 
        this.modal_id = this.$util.uuidv4(); 
    }
}
</script>
